import {authHeader, isTokenExpired} from '../helpers';

export const zoneService = {
  fetchZones,
  fetchZoneByFrame,
  fetchStatsForOneZone,
  uploadMediaToZones,
  setManualStat,
};

function fetchZones(frameId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/zones`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchZoneByFrame(frameId, targetLabel, index) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/zones/${targetLabel}/${index}`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchStatsForOneZone(frameId, target, zone) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/${target}/${zone}/statistics`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadMediaToZones(object) {
  const formData = new FormData()
  if (object.file) {
    formData.append('media', object.file, object.file.name)
  }
  if (object.link) {
    formData.append('link', object.link)
  }
  formData.append('zones', JSON.stringify(object.zones));
  formData.append('title', object.infos.title);
  formData.append('description', object.infos.description);

  const requestOptions = {
    method: 'PUT',
    headers: authHeader(true),
    body: formData,
  }

  const url = process.env.REACT_APP_API_URL + '/frames/zones/upload';

  return fetch(url, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function setManualStat(id, successToast, errorToast, fetchStat, infos = null) {
  let requestOptions;

  if (!infos) {
    requestOptions = {
      method: 'PUT',
      headers: authHeader(),
    };
  } else {
    requestOptions = {
      method: 'PUT',
      headers: authHeader(),
      body: JSON.stringify({
        hint: infos.hint,
        date: infos.date,
      })
    };
  }
  

  return fetch(`${process.env.REACT_APP_API_URL}/frame-zones/${id}/hint`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 200) {
        fetchStat();
        successToast();
        return res.text();
      } else {
        errorToast();
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}